// Set REACT_APP_USE_LEGACY_PRODUCT_QR_LABELS=true and rebuild to restore QR printing.
// Scanning accepts both formats regardless of this setting.
export const USE_LEGACY_PRODUCT_QR_LABELS =
  process.env.REACT_APP_USE_LEGACY_PRODUCT_QR_LABELS === "true";
